import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-col-7 p-m-0 p-p-0 right-border p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = {
  id: "informations-content",
  class: "kn-flex kn-relative"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-field p-col-12 p-d-flex" }
const _hoisted_6 = { class: "kn-flex" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "fileName",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid p-m-1" }
const _hoisted_10 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_13 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_16 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_17 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_20 = { class: "p-field p-col-12 p-d-flex" }
const _hoisted_21 = { class: "kn-flex" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = {
  for: "fileName",
  class: "kn-material-input-label"
}
const _hoisted_24 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_27 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_28 = { class: "p-float-label" }
const _hoisted_29 = {
  for: "engine",
  class: "kn-material-input-label"
}
const _hoisted_30 = {
  for: "datasource",
  class: "kn-material-input-label"
}
const _hoisted_31 = {
  key: 1,
  class: "p-field p-col-12 p-lg-6 p-d-flex"
}
const _hoisted_32 = { class: "kn-flex" }
const _hoisted_33 = { class: "p-float-label" }
const _hoisted_34 = {
  for: "dataset",
  class: "kn-material-input-label"
}
const _hoisted_35 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_36 = { class: "p-float-label" }
const _hoisted_37 = {
  for: "state",
  class: "kn-material-input-label"
}
const _hoisted_38 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_39 = { class: "p-float-label" }
const _hoisted_40 = {
  for: "refresh",
  class: "kn-material-input-label"
}
const _hoisted_41 = { class: "p-field p-col-12 p-lg-6 p-jc-center p-mt-3" }
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "far fa-eye p-ml-2" }, null, -1)
const _hoisted_43 = {
  for: "visible",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_44 = { class: "p-field p-col-12 p-lg-6 p-mt-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fas fa-lock p-ml-2" }, null, -1)
const _hoisted_46 = {
  for: "locked",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_47 = { class: "p-col-5 p-m-0 p-p-0 p-d-flex p-flex-column kn-flex" }
const _hoisted_48 = {
  id: "position-content",
  class: "kn-flex kn-relative"
}
const _hoisted_49 = {
  key: 0,
  id: "driver-position-container",
  class: "p-m-2"
}
const _hoisted_50 = { class: "p-field p-float-label p-col-12" }
const _hoisted_51 = { class: "p-dropdown-option" }
const _hoisted_52 = { class: "kn-capitalize" }
const _hoisted_53 = {
  for: "attributes",
  class: "kn-material-input-label"
}
const _hoisted_54 = {
  id: "restriction-container",
  class: "p-m-2"
}
const _hoisted_55 = { class: "p-formgrid p-grid p-mb-3" }
const _hoisted_56 = { class: "p-float-label p-col-10" }
const _hoisted_57 = {
  for: "profiledVisibility",
  class: "kn-material-input-label"
}
const _hoisted_58 = { class: "p-formgrid p-grid" }
const _hoisted_59 = { class: "p-field p-float-label p-col-12 p-lg-5" }
const _hoisted_60 = {
  for: "attributes",
  class: "kn-material-input-label"
}
const _hoisted_61 = { class: "p-field p-float-label p-col-12 p-lg-6" }
const _hoisted_62 = {
  for: "restrictionValue",
  class: "kn-material-input-label"
}
const _hoisted_63 = {
  id: "tree-container",
  class: "p-m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_DocumentDetailsTree = _resolveComponent("DocumentDetailsTree")
  const _component_DatasetDialog = _resolveComponent("DatasetDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.infoTitle')), 1)
        ]),
        end: _withCtx(() => [
          (_ctx.designerButtonVisible)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: _ctx.$t('documentExecution.olap.openDesigner'),
                class: "p-button-text p-button-plain",
                onClick: _ctx.openDesignerConfirm
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          _createVNode(_component_Card, { class: "p-m-2" }, {
            content: _withCtx(() => [
              (_ctx.templates.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        _createVNode("span", _hoisted_7, [
                          _createVNode(_component_InputText, {
                            id: "fileName",
                            class: "kn-material-input kn-width-full",
                            modelValue: _ctx.templateToUpload.name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateToUpload.name = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.uploadTemplate')), 1)
                        ])
                      ]),
                      _createVNode(_component_Button, {
                        icon: "fas fa-upload fa-1x",
                        class: "p-button-text p-button-plain p-ml-2",
                        onClick: _ctx.setUploadType
                      }, null, 8, ["onClick"]),
                      (!_ctx.uploading)
                        ? (_openBlock(), _createBlock(_component_KnInputFile, {
                            key: 0,
                            label: "",
                            changeFunction: _ctx.setTemplateForUpload,
                            triggerInput: _ctx.triggerUpload
                          }, null, 8, ["changeFunction", "triggerInput"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("form", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode(_component_InputText, {
                      id: "label",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.label.$invalid && _ctx.v$.document.label.$dirty
                                            }],
                      type: "text",
                      maxLength: "100",
                      modelValue: _ctx.v$.document.label.$model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.document.label.$model = $event)),
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.document.label.$touch())),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.label,
                    additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode("span", _hoisted_14, [
                    _createVNode(_component_InputText, {
                      id: "name",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.name.$invalid && _ctx.v$.document.name.$dirty
                                            }],
                      type: "text",
                      maxLength: "200",
                      modelValue: _ctx.v$.document.name.$model,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.document.name.$model = $event)),
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.document.name.$touch())),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.name,
                    additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_16, [
                  (_ctx.selectedDocument?.previewFile && !_ctx.imagePreview)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        id: "image-preview",
                        src: _ctx.getImageUrl,
                        height: _ctx.mainDescriptor.style.previewImage
                      }, null, 8, ["src", "height"]))
                    : _createCommentVNode("", true),
                  (_ctx.imagePreviewUrl && _ctx.imagePreview)
                    ? (_openBlock(), _createBlock("img", {
                        key: 1,
                        id: "image-preview",
                        src: _ctx.imagePreviewUrl,
                        height: _ctx.mainDescriptor.style.previewImage
                      }, null, 8, ["src", "height"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("span", _hoisted_18, [
                    _createVNode(_component_Textarea, {
                      id: "description",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.description.$invalid && _ctx.v$.document.description.$dirty
                                            }],
                      rows: "9",
                      maxLength: "400",
                      autoResize: true,
                      modelValue: _ctx.v$.document.description.$model,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.document.description.$model = $event)),
                      onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.document.description.$touch())),
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('common.description')), 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.description,
                    additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("span", _hoisted_22, [
                      _createVNode(_component_InputText, {
                        id: "fileName",
                        class: "kn-material-input",
                        modelValue: _ctx.document.previewFile,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.document.previewFile = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.previewImage')), 1)
                    ])
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-upload fa-1x",
                    class: "p-button-text p-button-plain p-ml-2",
                    onClick: _ctx.setImageUploadType
                  }, null, 8, ["onClick"]),
                  (_ctx.document.previewFile)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "fas fa-trash fa-1x",
                        class: "p-button-text p-button-plain p-ml-2",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('deleteImage')))
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_KnInputFile, {
                    changeFunction: _ctx.setImageForUpload,
                    accept: ".png, .jpg, .jpeg",
                    triggerInput: _ctx.triggerImageUpload
                  }, null, 8, ["changeFunction", "triggerInput"])
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", _hoisted_25, [
                    _createVNode(_component_Dropdown, {
                      id: "type",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.typeCode.$invalid && _ctx.v$.document.typeCode.$dirty
                                            }],
                      modelValue: _ctx.v$.document.typeCode.$model,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.document.typeCode.$model = $event)),
                      options: _ctx.documentTypes,
                      optionLabel: "translatedValueName",
                      optionValue: "valueCd",
                      onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.document.typeCode.$touch())),
                      onChange: _ctx.onTypeChange
                    }, null, 8, ["modelValue", "options", "class", "onChange"]),
                    _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('importExport.catalogFunction.column.type')) + " *", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.typeCode,
                    additionalTranslateParams: { fieldName: _ctx.$t('importExport.catalogFunction.column.type') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("span", _hoisted_28, [
                    _createVNode(_component_Dropdown, {
                      id: "engine",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.engine.$invalid && _ctx.v$.document.engine.$dirty
                                            }],
                      modelValue: _ctx.v$.document.engine.$model,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.document.engine.$model = $event)),
                      options: _ctx.filteredEngines,
                      optionLabel: "name",
                      optionValue: "label",
                      disabled: !_ctx.document.typeCode || _ctx.document.typeCode == '',
                      onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.document.engine.$touch())),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "options", "disabled", "class"]),
                    _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.engine')) + " *", 1)
                  ]),
                  _createVNode("small", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.engineHint')), 1),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.engine,
                    additionalTranslateParams: { fieldName: _ctx.$t('documentExecution.documentDetails.info.engine') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                (_ctx.isDataSourceVisible)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: ["p-field p-float-label p-col-12 p-lg-6", { 'p-lg-12': !_ctx.isDataSetVisible }]
                    }, [
                      _createVNode(_component_Dropdown, {
                        id: "datasource",
                        class: "kn-material-input",
                        modelValue: _ctx.document.dataSourceLabel,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.document.dataSourceLabel = $event)),
                        options: _ctx.availableDatasources,
                        optionLabel: "label",
                        optionValue: "label"
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('managers.businessModelManager.dataSource')), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.isDataSetVisible)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _createVNode("span", _hoisted_33, [
                          _createVNode(_component_InputText, {
                            id: "dataset",
                            class: "kn-material-input",
                            modelValue: _ctx.dataset.name,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dataset.name = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]),
                          _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('common.dataset')), 1)
                        ])
                      ]),
                      (_ctx.isDataSetVisible)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-search fa-1x",
                            class: "p-button-text p-button-plain p-ml-2",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showDatasetDialog = true))
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_35, [
                  _createVNode("span", _hoisted_36, [
                    _createVNode(_component_Dropdown, {
                      id: "state",
                      class: ["kn-material-input", {
                                                'p-invalid': _ctx.v$.document.stateCode.$invalid && _ctx.v$.document.stateCode.$dirty
                                            }],
                      modelValue: _ctx.v$.document.stateCode.$model,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.document.stateCode.$model = $event)),
                      options: _ctx.availableStates,
                      optionLabel: "translatedValueName",
                      optionValue: "valueCd",
                      onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.document.stateCode.$touch())),
                      onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "options", "class"]),
                    _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('common.state')) + " *", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.document.stateCode,
                    additionalTranslateParams: { fieldName: _ctx.$t('common.state') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_38, [
                  _createVNode("span", _hoisted_39, [
                    _createVNode(_component_InputText, {
                      id: "refresh",
                      class: "kn-material-input",
                      modelValue: _ctx.document.refreshSeconds,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.document.refreshSeconds = $event)),
                      type: "number"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.refresh')), 1)
                  ]),
                  _createVNode("small", null, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.refreshHint')), 1)
                ]),
                _createVNode("span", _hoisted_41, [
                  _createVNode(_component_InputSwitch, {
                    id: "visible",
                    modelValue: _ctx.document.visible,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.document.visible = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_42,
                  _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('common.visible')), 1)
                ]),
                _createVNode("span", _hoisted_44, [
                  _createVNode(_component_InputSwitch, {
                    id: "locked",
                    modelValue: _ctx.lockedByUser,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.lockedByUser = $event)),
                    onChange: _ctx.setIsLockedByUser
                  }, null, 8, ["modelValue", "onChange"]),
                  _hoisted_45,
                  _createVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('common.locked')), 1)
                ])
              ])
            ]),
            _: 1
          })
        ], 4)
      ])
    ]),
    _createVNode("div", _hoisted_47, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.positionTitle')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_48, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          (_ctx.document.drivers && _ctx.document.drivers.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_49, [
                _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
                  start: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.parametersPanelPosition')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, null, {
                  content: _withCtx(() => [
                    _createVNode("span", _hoisted_50, [
                      _createVNode(_component_Dropdown, {
                        id: "attributes",
                        class: "kn-material-input kn-width-full",
                        modelValue: _ctx.document.parametersRegion,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.document.parametersRegion = $event)),
                        options: _ctx.driversPositions,
                        optionLabel: _ctx.translatedLabel,
                        optionValue: "value"
                      }, {
                        option: _withCtx((slotProps) => [
                          _createVNode("div", _hoisted_51, [
                            _createVNode("span", _hoisted_52, _toDisplayString(_ctx.$t(slotProps.option.label)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "optionLabel"]),
                      _createVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.positionTitle')), 1)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_54, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.restrictionsTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Card, null, {
              content: _withCtx(() => [
                _createVNode("form", _hoisted_55, [
                  _createVNode("span", _hoisted_56, [
                    _createVNode(_component_Textarea, {
                      id: "profiledVisibility",
                      class: "kn-material-input kn-width-full",
                      rows: "1",
                      autoResize: true,
                      modelValue: _ctx.document.profiledVisibility,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.document.profiledVisibility = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.profiledVisibility')), 1)
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-plus-circle fa-1x",
                    class: "p-button-text p-button-plain p-ml-2 p-col-1",
                    disabled: !_ctx.visibilityAttribute,
                    onClick: _ctx.addRestriction
                  }, null, 8, ["disabled", "onClick"]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-eraser fa-1x",
                    class: "p-button-text p-button-plain p-ml-2 p-col-1",
                    onClick: _ctx.clearAllRestrictions
                  }, null, 8, ["onClick"])
                ]),
                _createVNode("form", _hoisted_58, [
                  _createVNode("span", _hoisted_59, [
                    _createVNode(_component_Dropdown, {
                      id: "attributes",
                      class: "kn-material-input kn-width-full",
                      modelValue: _ctx.visibilityAttribute,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.visibilityAttribute = $event)),
                      options: _ctx.availableAttributes,
                      optionLabel: "attributeName",
                      optionValue: "attributeName"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.attribute')), 1)
                  ]),
                  _createVNode("span", {
                    class: "p-col-12 p-lg-1",
                    style: _ctx.infoDescriptor.style.center
                  }, "=", 4),
                  _createVNode("span", _hoisted_61, [
                    _createVNode(_component_InputText, {
                      id: "restrictionValue",
                      class: "kn-material-input kn-width-full",
                      modelValue: _ctx.restrictionValue,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.restrictionValue = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('documentExecution.documentDetails.info.restrictionValueHint')), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_63, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.info.visibilityLocationTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Card, { class: "card-0-padding" }, {
              content: _withCtx(() => [
                _createVNode(_component_DocumentDetailsTree, {
                  propFunctionalities: _ctx.folders,
                  propSelectedFolders: _ctx.document.functionalities,
                  onSelected: _ctx.setFunctionality
                }, null, 8, ["propFunctionalities", "propSelectedFolders", "onSelected"])
              ]),
              _: 1
            })
          ])
        ], 4)
      ])
    ]),
    (_ctx.showDatasetDialog)
      ? (_openBlock(), _createBlock(_component_DatasetDialog, {
          key: 0,
          selectedDataset: _ctx.selectedDataset,
          visible: _ctx.showDatasetDialog,
          onCloseDialog: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showDatasetDialog = false)),
          onSaveSelectedDataset: _ctx.saveSelectedDataset
        }, null, 8, ["selectedDataset", "visible", "onSaveSelectedDataset"]))
      : _createCommentVNode("", true)
  ]))
}